import React from 'react';
import { ClockIcon, UsersIcon, GlobeIcon, BadgeCheckIcon, CalendarIcon } from 'lucide-react';
export function QuickInfoBar() {
  return <div className="bg-gray-50 border-y border-gray-200" data-id="element-1301">
      <div className="container mx-auto px-4 py-4" data-id="element-1302">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4" data-id="element-1303">
          <div className="flex items-center gap-3" data-id="element-1304">
            <ClockIcon size={20} className="text-blue-600 flex-shrink-0" data-id="element-1305" />
            <div data-id="element-1306">
              <div className="text-sm text-gray-500" data-id="element-1307">Duration</div>
              <div className="font-medium" data-id="element-1308">8D6N</div>
            </div>
          </div>
          <div className="flex items-center gap-3" data-id="element-1309">
            <UsersIcon size={20} className="text-blue-600 flex-shrink-0" data-id="element-1310" />
            <div data-id="element-1311">
              <div className="text-sm text-gray-500" data-id="element-1312">Group Size</div>
              <div className="font-medium" data-id="element-1313">Max 12 people</div>
            </div>
          </div>
          <div className="flex items-center gap-3" data-id="element-1314">
            <GlobeIcon size={20} className="text-blue-600 flex-shrink-0" data-id="element-1315" />
            <div data-id="element-1316">
              <div className="text-sm text-gray-500" data-id="element-1317">Languages</div>
              <div className="font-medium" data-id="element-1318">English, Spanish</div>
            </div>
          </div>
          <div className="flex items-center gap-3" data-id="element-1319">
            <BadgeCheckIcon size={20} className="text-blue-600 flex-shrink-0" data-id="element-1320" />
            <div data-id="element-1321">
              <div className="text-sm text-gray-500" data-id="element-1322">Tour Type</div>
              <div className="font-medium" data-id="element-1323">Guided Tour</div>
            </div>
          </div>
          <div className="flex items-center gap-3" data-id="element-1324">
            <CalendarIcon size={20} className="text-blue-600 flex-shrink-0" data-id="element-1325" />
            <div data-id="element-1326">
              <div className="text-sm text-gray-500" data-id="element-1327">Availability</div>
              <div className="font-medium" data-id="element-1328">Apr 2025 - Nov 2025</div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}